// Support "log in as customer" handoff for the /service/login route.
//
// The support tool opens /service/login?jwtToken=…&userId=…&customerId=…
// captureSupportLoginHandoff() runs in index.js BEFORE Sentry.init: it reads the
// credentials into memory and strips them from the address bar, so the JWT never
// reaches browser history, Referer headers or Sentry's pageload trace.
export const SUPPORT_LOGIN_PATH = '/service/login';

let handoff = null;

export const captureSupportLoginHandoff = (win = window) => {
    if (win.location.pathname !== SUPPORT_LOGIN_PATH) {
        return;
    }
    const params = new URLSearchParams(win.location.search);
    const jwtToken = params.get('jwtToken');
    const userId = params.get('userId');
    const customerId = params.get('customerId');

    handoff = jwtToken && userId && customerId ? {jwtToken, userId, customerId} : null;

    if (win.location.search) {
        win.history.replaceState(win.history.state, '', SUPPORT_LOGIN_PATH + win.location.hash);
    }
};

// Not cleared on read: React.StrictMode runs effects twice in development.
export const getSupportLoginHandoff = () => handoff;
